// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J8gq","fullView":"styles_fullView__1jxxZ"};